const EMAIL_REGEX =
  // eslint-disable-next-line regexp/no-unused-capturing-group -- Legacy functionality
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-z\-0-9]+\.)+[a-z]{2,}))$/i

export default (email) => (email ? Boolean(EMAIL_REGEX.test(email)) : false)
